/**
 * Resources Collapsible Component
 * Handles dynamic resource (PDF) display based on variant selection
 */

if (typeof window.ResourcesCollapsible === 'undefined') {
window.ResourcesCollapsible = class ResourcesCollapsible {
  constructor() {
    this.resourcesContainer = document.querySelector('[data-resources-display]');
    this.resourcesDataScript = document.querySelector('[data-resources-data]');
    this.collapsibleElement = document.querySelector('[data-resources-collapsible]');
    this.resourcesData = { exhaustive: true, variants: {} };
    this.lastVariantId = null;

    if (this.resourcesDataScript) {
      this.init();
    }
  }

  init() {
    try {
      const parsed = JSON.parse(this.resourcesDataScript.textContent || '{}');
      this.resourcesData = {
        exhaustive: parsed.exhaustive !== false,
        variants: parsed.variants || {}
      };
      this.bindEvents();
      this.setupMutationObserver();
    } catch (error) {
      console.error('Error initializing ResourcesCollapsible:', error);
    }
  }

  /**
   * Get the currently selected variant ID
   */
  getSelectedVariantId() {
    let input = document.querySelector('input[name="id"]:checked');
    if (input) return input.value;

    input = document.querySelector('select[name="id"]');
    if (input) return input.value;

    input = document.querySelector('input[name="id"]');
    if (input) return input.value;

    return null;
  }

  /**
   * Update the resources display based on variant
   */
  updateResourcesDisplay() {
    const variantId = this.getSelectedVariantId();
    if (!variantId || !this.resourcesContainer) return;

    const variantResources = this.resourcesData.variants[variantId];

    // Non-exhaustive data (V2 products) only carries the variant selected at
    // render time. A miss here means "not fetched yet", not "no resources" —
    // leave the DOM alone rather than hiding the section, since the correct
    // variant's resources are server-rendered directly (not sourced from this
    // map) whenever this component's own listeners do fire.
    if (variantResources === undefined && !this.resourcesData.exhaustive) {
      return;
    }

    if (variantResources && variantResources.length > 0) {
      // Filter to only valid URLs for security
      const validResources = variantResources.filter(resource =>
        this.isValidUrl(resource.path)
      );

      if (validResources.length > 0) {
        this.resourcesContainer.innerHTML = validResources.map(resource =>
          `<div class="resource-item">
            <a href="${this.escapeHtml(resource.path)}" target="_blank" rel="noopener noreferrer" class="resource-link">${this.escapeHtml((resource.title || '').trim())}</a>
          </div>`
        ).join('');

        // Show the section
        if (this.collapsibleElement) {
          this.collapsibleElement.style.display = '';
          this.collapsibleElement.removeAttribute('hidden');
        }
      } else {
        // No valid resources, hide the section
        this.resourcesContainer.innerHTML = '';
        if (this.collapsibleElement) {
          this.collapsibleElement.style.display = 'none';
        }
      }
    } else {
      // No resources for this variant, hide the section
      this.resourcesContainer.innerHTML = '';
      if (this.collapsibleElement) {
        this.collapsibleElement.style.display = 'none';
      }
    }

    // Update the data-variant-id attribute
    this.resourcesContainer.setAttribute('data-variant-id', variantId);
  }

  /**
   * Escape HTML to prevent XSS
   */
  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Validate URL for security (defense in depth)
   * @param {string} url - URL to validate
   * @returns {boolean} True if URL is valid and uses http/https protocol
   */
  isValidUrl(url) {
    if (!url || typeof url !== 'string') return false;
    try {
      const parsed = new URL(url);
      return ['http:', 'https:'].includes(parsed.protocol);
    } catch {
      return false;
    }
  }

  /**
   * Bind event listeners
   */
  bindEvents() {
    // Listen for variant changes via input change
    document.addEventListener('change', (event) => {
      if (event.target.name === 'id') {
        this.updateResourcesDisplay();
      }
    });

    // Listen for custom variant change events
    document.addEventListener('variant:change', () => {
      this.updateResourcesDisplay();
    });

    document.addEventListener('variant:changed', () => {
      this.updateResourcesDisplay();
    });
  }

  /**
   * Setup mutation observer for efficient change detection
   */
  setupMutationObserver() {
    const observer = new MutationObserver(() => {
      const currentVariantId = this.getSelectedVariantId();
      if (currentVariantId && currentVariantId !== this.lastVariantId) {
        this.lastVariantId = currentVariantId;
        this.updateResourcesDisplay();
      }
    });

    // Observe changes to the product form or variant selectors
    const productForm = document.querySelector('product-form, [data-product-form]');
    if (productForm) {
      observer.observe(productForm, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-variant-id', 'value']
      });
    }
  }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  new window.ResourcesCollapsible();
});
}
